
class I18nHelper {
  constructor () {
    this.supportedLocales = [
      { code: 'cn', name: '简体' },
      { code: 'tw', name: '繁体' }
    ]
    this.locale = this.getCurrentLocale() || 'cn'
  }

  // 获取当前语言
  getCurrentLocale () {
    return localStorage.getItem('app-locale') || 'cn'
  }

  // 设置语言
  setLocale (locale) {
    localStorage.setItem('app-locale', locale)
    this.locale = locale
  }

  // 获取支持的语言列表
  getSupportedLocales () {
    if (window.OpenCC) {
      const option = {
        from: 'cn',
        to: 'tw'
      }
      if (this.locale === 'cn') {
        option.from = 'tw'
        option.to = 'cn'
      }
      const converter = window.OpenCC.Converter(option)
      const text = JSON.stringify(this.supportedLocales)
      return JSON.parse(converter(text))
    }
    return this.supportedLocales
  }

  $t (text) {
    if (window.OpenCC) {
      const option = {
        from: 'cn',
        to: 'tw'
      }
      if (this.locale === 'cn') {
        option.from = 'tw'
        option.to = 'cn'
      }
      const converter = window.OpenCC.Converter(option)
      return converter(text)
    }
    return text
  }
}

export const i18n = new I18nHelper()

export default {
  install (Vue) {
    Vue.prototype.$i18n = i18n
  }
}
